
import Vue from "vue";
import DogRegistrationIndividualRequest from "@/components/Portal/MyRequest/DogRegistrationIndividualRequest.vue";
import RegistrationRequestLayout from "@/components/common/RegistrationRequestLayout.vue";
import workflowService from "@/services/admin/workflowService";
import CoownersList, { OwnershipType } from "@/components/common/CoownersList.vue";

export default Vue.extend({
  name: "DogRegistrationIndividualRequestCard",
  props: {
    requestId: { type: Number },
  },
  components: {
    RegistrationRequestLayout,
    DogRegistrationIndividualRequest,
    CoownersList,
  },
  data: function () {
    return {
      registration: {
        workflowGuid: "",
        requestId: 0,
        dogId: null as string | null,
      } as any,
    };
  },
  computed: {
    workflowService() {
      return workflowService;
    },
    dogOwnershipType: function() {
     return OwnershipType.Dog;
    },
  },
  methods: {
    onRequestProcessed: function (requestId: number) {
      workflowService.getDogRegistrationIndividualRequestById(requestId).then((res: { data: any; }) => {
        if(!!res.data.dogId) {
          this.$router.push({ path: `/admin/dogs/${res.data.dogId?.trim()}` }).catch(()=>{});
        } else {
          this.$router.push({ path: '/admin/registration/dogs/individual' });
        }
      });
    },
  },
});
